import { postWishlist } from './muun-WL-postWishlist.js';
import { getSharedWishlist, updateWishlist } from './muun-WL-state.js';
import { readLocalWishlist, saveLocalWishlist } from './muun-wl-helpers.js';

// TEMPLATE
const template = document.createElement('template');
template.innerHTML = `
    <style>
      :host([style-attribute="title"]) .heart__container {
        width: 50px;
        height: 50px;
        display: flex;
        justify-content: end;
        align-items: start;
        transform: translateY(-10px);
      }
      :host([style-attribute="title"]) .heartTitle__heart {
        width: 30px;
        height: 29px;
        padding: 0.5rem;
        -webkit-transition: background-color 0.25s linear;
        transition: background-color 0.15s linear 0.1s;
        cursor: pointer;
        background-color: transparent;
      }
      :host([style-attribute="card"]) .heart__container {
        background-color: #FFFFFF;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        -webkit-transition: opacity 0.25s linear;
        transition: opacity 0.15s linear 0.1s;
        opacity: 0.8;
      }
      :host([style-attribute="card"]) .heart__container:hover {
        opacity: 1;
      }
      :host([style-attribute="card"]) .heartTitle__heart {
      width: 18px;
      height: 17px;
      padding: 0.5rem;
      -webkit-transition: background-color 0.25s linear;
      transition: background-color 0.15s linear 0.1s;
      cursor: pointer;
      background-color: transparent;
      }
      input[type="checkbox"] {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;
      }
      input[type="checkbox"] + label #checked-img {
      display: none;
      }
      input[type="checkbox"] + label #unchecked-img {
      display: block;
      }
      input[type="checkbox"]:checked + label #checked-img {
      display: block;
      }
      input[type="checkbox"]:checked + label #unchecked-img {
      display: none;
      }
    </style>
    <div class="heart__container">
        <input type="checkbox" id="toggle_favorites">
        <label for="toggle_favorites">
          <svg
            class="heartTitle__heart"
            id="unchecked-img"
            width="18"
            height="17"
            viewBox="-15 -15 230 214"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          > 
          <path fill='#1d1e1b' stroke='#1d1e1b' stroke-width='7' d='M103.59 190.83C102.05 190.83 100.5 190.38 99.18 189.47C97.59 188.37 59.82 162.16 31.2 126.45C16.98 108.71 7.57 91.74 3.24 76.03C-2.12 56.56 0.260011 38.92 10.34 23.59C22.38 5.26999 40.44 -2.66001 59.9 1.80999C79.51 6.31999 96.69 22.32 103.59 41.2C110.49 22.32 127.67 6.31999 147.28 1.80999C166.73 -2.67001 184.8 5.26999 196.84 23.59C206.91 38.92 209.3 56.56 203.94 76.03C199.61 91.74 190.21 108.7 175.98 126.45C147.35 162.16 109.59 188.37 108 189.47C106.68 190.38 105.14 190.83 103.59 190.83ZM49.25 6.22999C35.8 6.22999 23.9 13.28 15.08 26.7C-1.83 52.43 5.08001 84.79 35.62 122.9C63.73 157.97 100.83 183.72 102.39 184.8C103.11 185.3 104.05 185.3 104.77 184.8C106.34 183.72 143.43 157.97 171.55 122.9C202.09 84.8 209.01 52.43 192.09 26.7C181.27 10.24 165.8 3.36 148.54 7.33C127.63 12.14 109.11 32.34 106.39 53.31C106.21 54.72 105 55.78 103.58 55.78C102.16 55.78 100.95 54.72 100.77 53.31C98.05 32.34 79.54 12.14 58.62 7.33C55.42 6.6 52.29 6.22999 49.24 6.22999H49.25Z'/>
          </svg>
          <svg
            class="heartTitle__heart"
            id="checked-img"
            width="18"
            height="17"
            viewBox="-15 -15 230 214"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          > 
          <path d='M100.79 49.95C95.63 10.15 39.61 -23.05 9.91001 22.14C-31.85 85.67 77.52 170.02 97.99 184.13C99.68 185.29 101.9 185.29 103.59 184.13C124.06 170.02 233.43 85.68 191.67 22.14C161.97 -23.05 105.96 10.14 100.79 49.95Z' fill='#1D1E1B'/>
          </svg>
        </label>
    </div>
    `;

class WishlistButton extends HTMLElement {
  constructor() {
    super();
    this.shadow = this.attachShadow({ mode: 'open' });

    this.productId = this.getAttribute('product-id');
    this.customerId = this.getAttribute('customer-id');
    this.shopDomain = this.getAttribute('shop-domain');
    this.isLoggedIn = this.getAttribute('is-logged-in') === 'true';
    this.addLabel = this.getAttribute('add-label');
    this.removeLabel = this.getAttribute('remove-label');
    this.wishlistData = [];
    this.shadow.append(template.content.cloneNode(true));
  }
  async connectedCallback() {
    this.isAlreadyInWishlist = false;
    this.heartToggle = this.shadowRoot.querySelector('#toggle_favorites');

    // CHECK FOR WISHLIST DATA
    try {
      this.wishlistData = await getSharedWishlist(this.isLoggedIn, this.customerId, this.shopDomain);
    } catch (e) {
      this.wishlistData = [];
    }
    this.isAlreadyInWishlist = this.wishlistData.some((elem) => elem.productId == this.productId);

    // ADD TITLES FOR ACCESSIBILITY
    const uncheckedSVG = this.shadowRoot.querySelector('#unchecked-img');
    const checkedSVG = this.shadowRoot.querySelector('#checked-img');
    if (uncheckedSVG) {
      const title = document.createElement('title');
      title.textContent = this.addLabel || 'Add to Wishlist';
      uncheckedSVG.prepend(title);
    }
    if (checkedSVG) {
      const title = document.createElement('title');
      title.textContent = this.removeLabel || 'Remove from Wishlist';
      checkedSVG.prepend(title);
    }
    uncheckedSVG.setAttribute('title', this.addLabel || 'Add to Wishlist');
    checkedSVG.setAttribute('title', this.removeLabel || 'Remove from Wishlist');

    // HEART TOGGLEING
    if (this.heartToggle) {
      // check or uncheck heart initially
      this.heartToggle.checked = this.isAlreadyInWishlist;
      // toggle heart
      this.heartToggle.addEventListener('change', async () => {
        // ADD
        if (this.heartToggle.checked) {
          if (this.isLoggedIn) {
            await postWishlist(this.customerId, this.productId, this.shopDomain, 'CREATE', 1);
            this.wishlistData = await updateWishlist(this.isLoggedIn, this.customerId, this.shopDomain);
          } else {
            let localWishlist = readLocalWishlist();
            const exists = localWishlist.some((item) => item.productId === this.productId);
            if (!exists) {
              localWishlist.unshift({
                productId: this.productId,
                productAmount: 1,
              });
              saveLocalWishlist(localWishlist);
            }
            this.wishlistData = await updateWishlist(this.isLoggedIn, this.customerId, this.shopDomain);
          }
          // REMOVE
        } else {
          if (this.isLoggedIn) {
            await postWishlist(this.customerId, this.productId, this.shopDomain, 'DELETE');
            this.wishlistData = await updateWishlist(this.isLoggedIn, this.customerId, this.shopDomain);
          } else {
            let localWishlist = readLocalWishlist();
            localWishlist = localWishlist.filter((item) => item.productId !== this.productId);
            saveLocalWishlist(localWishlist);
          }
        }
        this.isAlreadyInWishlist = !this.isAlreadyInWishlist;
      });
    }
  }
}
customElements.define('wishlist-button', WishlistButton);
